import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import {
    Autocomplete,
    Box,
    Checkbox,
    ClickAwayListener,
    //Divider,
    //FormControlLabel,
    //Paper,
    TextField,
    Typography
} from "@mui/material";
import Switch from "@mui/material/Switch";
import PropTypes from "prop-types";
import { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core";
import classes from '../CustomInputs.module.css';
import { removeDuplicatesInArray } from "../../../../utils/CommonUtils";
import { InputInfo } from "../../../../entities/UIEntities/Form Entities/InputInfo";
import store from "../../../../redux/Store";
import Strings from "../../../../resources/Strings";
import { CAMPAIGN_TYPES, TABLES } from "../../../../enums/Enums";
import { getRecipientsParkersData, getUsersByRecipients } from "../../../../utils/MessagingUtils";
import { TableModalEntity } from "../../../../entities/UIEntities/TableModalEntity";
import { RECIPIENTS_TABLE_COLUMNS } from "../../../../constants/Constants";
import { commonActions } from "../../../../redux/reducers/CommonReducer";

const useStyles = makeStyles({
    option: {
      background: "white !important",
      "&:hover": {
        background: "rgb(245,245,245) !important",
        // clip - prevents the background from covering the padding as well
        backgroundClip: "content-box !important" 
      }
    }
  });

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const MultiSelectBoxInput = (props) => {
    const styles = useStyles();
    const { items, foundedItems, label, placeholder, showTotal, currentUsers, mailingLists } = props;
    const [selectedItems, setSelectedItems] = useState([]); 
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [totalCounter, setTotalCounter] = useState(0);
    const [open, setOpen] = useState(false);

    const startAdornmentDivRef = useRef(null);
    //const [isOverflowActive, setIsOverflowActive] = useState(false);
    //const [reachedBottom, setReachedBottom] = useState(false); 

    // const handleScroll = () => {
    //     console.log("maxContentHeightPos", startAdornmentDivRef?.current.scrollHeight - startAdornmentDivRef?.current.offsetHeight);
    //     console.log("currentScrollPos", startAdornmentDivRef?.current.scrollTop);

    //     if (startAdornmentDivRef?.current.scrollTop === startAdornmentDivRef?.current.scrollHeight - startAdornmentDivRef?.current.offsetHeight) {
    //         console.log("reached bottom");
    //         setReachedBottom(true);
    //     }
    //     else {
    //         console.log("user is scrolling");
    //         setReachedBottom(false);
    //     }
    // };

    useEffect(() => {
      if (props.handleError) {
         props.handleError({ [props.id]: props.hasError });
      }
      if (props.handleInputInfo) {
        props.handleInputInfo(new InputInfo(props.id, selectedItems, props.isRequired, props.hasError));
      }

      // handles auto scroll to bottom for every selection
      handleScrollForSelection();
      //handleOverflow();

      // when mailing lists passed, get the current total number for every selection
      if (showTotal && currentUsers?.length > 0 && mailingLists?.length > 0) {
        const total = getUsersByRecipients({recipients: selectedItems, mailingLists, currentUsers})?.length;
        setTotalCounter(total);
      }
    }, [selectedItems]);

    useEffect(() => {
        setSelectedItems(foundedItems?.length > 0 ? foundedItems : []);
    }, [foundedItems]);

    const handleScrollForSelection = () => {
        // for every selection check if possible to scroll down, if yes (when there is available gap) 
        // set the current scroll position to bottom
        const maxContentHeightPos = startAdornmentDivRef?.current.scrollHeight - startAdornmentDivRef?.current.offsetHeight;
        const currentScrollPos = startAdornmentDivRef?.current.scrollTop;
        if (currentScrollPos < maxContentHeightPos) {
            startAdornmentDivRef.current.scrollTop = maxContentHeightPos;
        }       
    };

    // const handleOverflow = () => {
    //     // check if overflow is active
    //     const localOverflow = startAdornmentDivRef?.current.clientHeight < startAdornmentDivRef?.current.scrollHeight;
    //     setIsOverflowActive(localOverflow);
    // };
      
    const getSortedItems = () => { 
        // Sorts all items on every group, and initial groups order will remain the same
        let sortedItems = [];

        // Get all groups, with distinct
        const allGroups = items?.filter((item, index) => items?.findIndex((i) => i.title === item.title) === index); // distinct array

        // For every group sort its items
        allGroups.forEach(group => {
            let filteredItemsByGroup = items?.filter(item => item.title === group.title);
            filteredItemsByGroup.sort((a, b) => {
                const identifierNameA = a.identifierName?.toLowerCase();
                const identifierNameB = b.identifierName?.toLowerCase();
    
                if (identifierNameA < identifierNameB) {
                    return -1; // put before
                }
                if (identifierNameA > identifierNameB) {
                    return 1; // put after
                }
    
                return 0;     // no change
            });

            // Add the sorted group items to the sortedItems as for the result
            sortedItems = sortedItems.concat(filteredItemsByGroup);
        });

        return sortedItems;

        // return items.sort((a, b) =>
        //     a.title.toLowerCase() < b.title.toLowerCase()
        //         ? -1
        //         : b.title.toLowerCase() > a.title.toLowerCase()
        //             ? 1
        //             : 0
        // );
    };

    const handleClickAway = (event) => {
        setOpen(false);
    };

    const handleSelectGroup = (groupName, isChecked) => {
        let localSelectedItems = [];
        if (isChecked) {
            localSelectedItems = removeDuplicatesInArray(selectedItems.concat(items.filter((item) => item.title === groupName)));
        } else {
            localSelectedItems = removeDuplicatesInArray(selectedItems.filter((item) => item.title !== groupName));
        }
        
        setSelectedItems(localSelectedItems);
        props.onItemClicked(localSelectedItems);
    };

    const handleLabel = () => {
        let labelRes = label;

        // when mailing lists passed, in both cases show counter only if greater than 0
        if (showTotal && currentUsers?.length > 0 && mailingLists?.length > 0) {
            if (totalCounter > 0) {
                labelRes = `${label} ${Strings.TOTAL}: ${totalCounter}`
            }
        }
        else if (showTotal) {
            if (selectedItems?.length > 0) {
                labelRes = `${label} ${Strings.TOTAL}: ${selectedItems?.length}`;
            }
        }

        return labelRes;
    };

    const openValidRecipientsTableModal = (validRecipients) => {
        const validRecipientsTableModal = new TableModalEntity(
          `${Strings.VALID_RECIPIENTS} (${validRecipients?.length})`,
          RECIPIENTS_TABLE_COLUMNS,
          validRecipients, 
          TABLES.MODAL_TABLE 
        );
    
        store.dispatch(commonActions.setTableModal(validRecipientsTableModal));
      };

    // const handleSelectAll = () => {
    //     setIsSelectAll((prevState) => {
    //         !prevState ? setSelectedItems([...items]) : setSelectedItems([]);
    //         return !prevState;
    //     });
    // };

    // const SelectAllComponent = ({ children, ...paperProps }) => {
    //     const { ...restPaperProps } = paperProps;
    //     return (
    //         <Paper {...restPaperProps}>
    //             <Box onMouseDown={(e) =>
    //                 e.preventDefault()}
    //                 paddingLeft={1.5}
    //                 paddingTop={0.5}
    //             >
    //                 <FormControlLabel
    //                     onClick={(e) => {
    //                         e.preventDefault();
    //                         handleSelectAll();
    //                         props.onItemClicked(items);
    //                     }}
    //                     label={'Select All'}
    //                     control={
    //                         <Checkbox
    //                             checked={isSelectAll}
    //                         />
    //                     }
    //                 />
    //             </Box>
    //             <Divider />
    //             {children}
    //         </Paper>
    //     );
    // };

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <Box className={classes.customTextField}>
                <Autocomplete
                    multiple
                    disableCloseOnSelect
                    value={selectedItems}
                    //options={items}
                    options={getSortedItems()}
                    filterOptions={(options, params) => {
                        const { inputValue } = params;

                        // Suggest the options by input value, check if matches any title (Mailing List / Transient) or user name
                        const filteredOptions = options.filter(item => 
                         item.title?.toLowerCase()?.includes((inputValue)?.toLowerCase()) || 
                         item.identifierName?.toLowerCase()?.includes((inputValue)?.toLowerCase()));

                        return filteredOptions;
                    }}
                    className={classes.textField}
                    getOptionLabel={(option) => option.id.toString()} // option.identifierName
                    groupBy={(option) => option.title}
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    onChange={(event, newValue, reason) => {
                        if (reason === "selectOption") {
                            setSelectedItems(newValue);
                        } else if (reason === "removeOption") {
                            setIsSelectAll(false);
                            setSelectedItems(newValue);
                        } else if (reason === "clear") {
                            setSelectedItems([]);
                            setIsSelectAll(false);
                        }

                        props.onItemClicked(newValue);
                    }}
                    ChipProps={{onClick: (event) => {
                        // When clicking on a selected mailing list inside input, show its recipients
                        // disable opening the options (assures only table modal will be opened if founded)
                        setOpen(false);

                        // Find mailing list by the option name
                        const foundedMailingList = mailingLists?.find(ml => ml.name === event?.target?.innerText);
                        const foundedMailingListItem = selectedItems?.find(item => item.identifierName === event?.target?.innerText);

                        // When both mailng list founded, and the mailing list as item founded,
                        // start arranging the data for the founded mailing list
                        if (foundedMailingList !== undefined && foundedMailingListItem !== undefined) {
                            const usersFromFoundedMailingList = getUsersByRecipients({recipients: [foundedMailingListItem], mailingLists: [foundedMailingList], currentUsers});
                            const allRecipients = getRecipientsParkersData(usersFromFoundedMailingList);
                            const validRecipients = allRecipients?.filter(recipient => recipient.subscriptionStatus === Strings.SUBSCRIBED && (recipient.reason === "" || (recipient.reason !== "" && (props.campaignType.value === CAMPAIGN_TYPES.MAIL && recipient.email !== Strings.NOT_AVAILABLE || props.campaignType.value === CAMPAIGN_TYPES.MOBILE && recipient.phoneNumber !== Strings.NOT_AVAILABLE))))
                            
                            // Double checks if there is any recipients on the maling list
                            if (validRecipients?.length > 0) {
                                openValidRecipientsTableModal(validRecipients);
                            }
                        }
                    }}}
                    renderInput={(params) => {
                        // user selects id as option
                        // in order to render the selection as name, maps the selected id option to name   
                        let startAdornmentCopy = [];
                        let inputPropsCopy = {...params.InputProps};
                        let paramsCopy = {...params};

                        if (paramsCopy?.InputProps?.startAdornment?.length > 0) {
                            startAdornmentCopy = [...params.InputProps?.startAdornment];
                            startAdornmentCopy = startAdornmentCopy?.map(element => {
                                let elementPropsCopy = {...element.props}
                                let elementCopy = {...element};
                                elementCopy.props = elementPropsCopy;

                                let foundedItemElement = items?.find(item => item.id === parseInt(element?.props?.label));
                                elementCopy.props.label = foundedItemElement.identifierName;   
                                return {...elementCopy};
                             });
                        }

                        // assign to paramsCopy
                        inputPropsCopy.startAdornment = startAdornmentCopy;
                        paramsCopy.InputProps = inputPropsCopy;

                        return (
                          <TextField
                            {...paramsCopy} /*{...params}*/
                            error={props.isStepSubmitted && props.hasError}
                            helperText={
                              props.isStepSubmitted && props.hasError ? props.errorMessage : ""
                            }
                            InputLabelProps={{
                              ...params.InputLabelProps,
                              shrink: true,
                            }}
                            InputProps={{
                              ...paramsCopy.InputProps,
                              startAdornment: (
                                <div ref={startAdornmentDivRef} className={classes.recipientsOpened} onClick={() => setOpen(true)} /*onScroll={() => handleScroll()}*/ >
                                    {paramsCopy.InputProps.startAdornment}
                                </div>
                              ), 
                            }}
                            label={handleLabel()}
                            placeholder={placeholder}
                            FormHelperTextProps={{
                              classes: {
                                error: classes.error,
                              },
                            }}
                          />
                        );
                    }}
                    renderOption={({ key, ...props }, option, { selected }) => {
                        return (
                            <Box className={classes.appInput} key={key}>
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        checked={selected || isSelectAll}
                                        classes={{
                                            checked: classes.switchChecked
                                        }}
                                    />
                                    {option?.identifierName}
                                </li>
                            </Box>
                        );
                    }}
                    renderGroup={(item) => {
                        const { group, children } = item;

                        var currentGroupItems = items.filter((item) => item.title === group);
                        var currentSelectedItemsInGroup = selectedItems.filter((selectedItem) => selectedItem.title === group);
                        var isChecked = currentGroupItems.length === currentSelectedItemsInGroup.length;

                        return (
                            <Box key={group}>
                                <Box sx={{marginLeft: '10px'}}>{group}</Box>
                                <Box className={classes.appInput} style={{ display: "flex", flexDirection: "row", alignItems: 'center' }}>
                                    <Switch
                                        checked={isChecked}
                                        onChange={(event) => handleSelectGroup(group, event.target.checked)}
                                        className={classes.switch}
                                        classes={{
                                            checked: classes.switchChecked,
                                            track: classes.switchTrack,
                                            switchBase: isChecked ? classes.switchChecked : ''
                                        }}
                                    />
                                    <Typography sx={{ fontWeight: isChecked ? "bold" : "regular" }}>{"Select All"}</Typography>
                                </Box>
                                <Box>{children}</Box>
                            </Box>
                        );
                    }}
                    classes={{
                        option: styles.option,
                        inputRoot: classes.noLimitFiled,
                        // inputRoot: isOverflowActive ? [classes.noLimitFiled, classes.recipientsOverflowInputRoot].join(' ') : classes.noLimitFiled,
                        // input: (isOverflowActive && !reachedBottom) && classes.recipientsOverflowInput
                        // input: isOverflowActive && classes.recipientsOverflowInput
                        // paper: classes.menuPaper,
                        // listbox: classes.listbox
                    }}
                    slotProps={{
                        popper: {
                          // add offset gap of 10 units from input element
                          modifiers: [
                            {
                              name: "offset",
                              options: {
                                offset: [0, 10],
                              },
                            },
                          ],
                        },
                    }}
                // PaperComponent={(paperProps) => {
                //     const { children, ...restPaperProps } = paperProps;
                //     return (
                //         <Paper {...restPaperProps}>
                //             <Box onMouseDown={(e) =>
                //                 e.preventDefault()}
                //                 paddingLeft={1.5}
                //                 paddingTop={0.5}
                //             >
                //                 <FormControlLabel
                //                     onClick={(e) => {
                //                         e.preventDefault();
                //                         handleSelectAll();
                //                         props.onItemClicked(items);
                //                     }}
                //                     label={'Select All'}
                //                     control={
                //                         <Checkbox
                //                             checked={isSelectAll}
                //                         />
                //                     }
                //                 />
                //             </Box>
                //             <Divider />
                //             {children}
                //         </Paper>
                //     );
                // }}
                // PaperComponent={SelectAllComponent}
                />
            </Box>
        </ClickAwayListener>
    );
};

MultiSelectBoxInput.propTypes = {
    items: PropTypes.array,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    onItemClicked: PropTypes.func
};

export default MultiSelectBoxInput;